import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const usuEntPerfilesApi = `${baseUrl}/usuario-entidad-perfiles`;

export const allUsuEntPerfilesService = async (params) => {
  const res = await axios.get(usuEntPerfilesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveUsuEntPerfilesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${usuEntPerfilesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(usuEntPerfilesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const deleteUsuEntPerfilesService = async (id) => {
  const res = await axios.delete(`${usuEntPerfilesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
